import { IStateSpuCPM } from 'src/entity/StateEntity';
import { SPU_CPM_STATUS_RELOAD, SPU_CPM_STATUS_SUCCESS, SPU_CPM_STATUS_REQUEST, SPU_CPM_STATUS_FAILURE } from 'src/constants/ActionTypes';

const initialState: IStateSpuCPM = {
  reload: true,
  isFetching: false,
  type: SPU_CPM_STATUS_RELOAD,
  cpmList: [],
};

export const spuCpmState = (state: IStateSpuCPM = initialState, action: IStateSpuCPM): IStateSpuCPM => {
  switch (action.type) {
    case SPU_CPM_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        cpmList: action.cpmList,
      });

    case SPU_CPM_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        cpmList: [],
      });

    case SPU_CPM_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        cpmList: [],
      });

    case SPU_CPM_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        cpmList: [],
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/spuCpmState.ts